module.exports = __webpack_public_path__ + "img/tips3list2img19120302.c95864c0.jpg";